// frontend/src/services/mediaService.js
import { useState, useEffect, useCallback } from 'react';
import api from './api';
import { MEDIA_BASE_URL } from '../config';
import { useAuthContext } from '../context/AuthContext';

export const useSecureMedia = (mediaId) => {
    const [mediaUrl, setMediaUrl] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const { openAuthModal } = useAuthContext();

    const fetchMediaUrl = useCallback(async (id) => {
        // ✅ اگر mediaId وجود نداشت، خطا نده و فقط reset کن
        if (!id) {
            setMediaUrl(null);
            setError(null);
            return;
        }

        setIsLoading(true);
        setError(null);

        try {
            console.log(`🔒 [useSecureMedia] Fetching secure URL for media ${id}...`);
            // ✅ اصلاح آدرس: اضافه کردن api/v1
            const response = await api.get(`/api/v1/products/protected-url/${id}/`);
            
            console.log(`✅ [useSecureMedia] Response for ${id}:`, response.data);

            if (response.data && response.data.presigned_url) {
                setMediaUrl(response.data.presigned_url);
            } else if (response.data && response.data.media_url) {
                setMediaUrl(MEDIA_BASE_URL + response.data.media_url);
            } else {
                throw new Error("پاسخ سرور فاقد URL بود.");
            }
        } catch (err) {
            console.error(`❌ [useSecureMedia] Error for ${id}:`, {
                status: err.response?.status,
                data: err.response?.data,
                message: err.message,
            });
            
            if (err.response && err.response.status === 401) {
                openAuthModal();
                setError("خطای احراز هویت: لطفاً وارد شوید.");
            } else if (err.response && err.response.status === 403) {
                setError("خطای مجوز: شما دسترسی لازم برای مشاهده این فایل را ندارید.");
            } else {
                setError(err.message || "خطا در بارگذاری مدیا");
            }
        } finally {
            setIsLoading(false);
        }
    }, [openAuthModal]);

    useEffect(() => {
        fetchMediaUrl(mediaId);
    }, [mediaId, fetchMediaUrl]);

    return { mediaUrl, isLoading, error, refetch: fetchMediaUrl };
};

export const getSecureMediaUrl = (mediaId) => {
    return `${api.defaults.baseURL}api/v1/products/protected-url/${mediaId}/`;
};

const mediaService = {
    useSecureMedia,
    getSecureMediaUrl
};

export default mediaService;